import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router";

import GuestRoute from "helpers/authentication/guestRoute";
import AuthRoute from "helpers/authentication/authRoute";

import Layout from "./components/Layout/Layout";
import Dashboard from "views/dashboard";
import NotFound from "views/NotFound";
import Login from "views/login";
import Logout from "views/Logout";
import { getAllSettings, getCurrentUser } from "store/actions";
import Loader from "./components/shared/Loader";

import Settings from "views/Settings";

import Intro from "views/home/intro";

import CompanyProfile from "views/home/companyProfile";




import CustomerReviewsAbout from "views/about/customerReviews";
import Values from "views/about/values";

import Partners from "views/partners";
import EditPartner from "views/partners/EditPartner";
import AddPartner from "views/partners/AddPartner";
import PartnersHeading from "views/partners/Heading";
import ContactUs from "views/ContactUs";

import Socials from "views/socials";
import AddSocial from "views/socials/AddSocial";
import EditSocial from "views/socials/EditSocial";
import ShowContact from "views/ContactUs/ShowContact";


import AddBlog from "views/blogs/AddBlog";

import AddBlogCategory from "views/blogsCategories/AddBlogCategory";
import EditBlogCategory from "views/blogsCategories/EditBlogCategory";
import Blogs from "views/blogs/Index";
import BlogCategories from "views/blogsCategories/Index";
import EditBlog from "views/blogs/EditBlog";



import ContactUsHeading from "views/ContactUs/Heading";
// import BannerContent from "views/blogs/banner";
import SocialTypes from "views/socialTypes";
import AddSocialTypes from "views/socialTypes/AddSocial";
import EditSocialType from "views/socialTypes/EditSocial";

import Statics from "views/home/statics";




import DistinguishUs from "views/about/distinguishUs";






import FooterBackground from "views/ContactUs/FooterBackground";
import Services from "views/home/services";
import CompanyProfileUpload from "views/home/companyProfileUpload";
import CustomerReviews from "views/home/customerReviews";
import OurServices from "views/ourServices/Index";
import AddServices from "views/ourServices/AddService";
import EditServices from "views/ourServices/EditSevice";
import OurWorks from "views/ourWorks/Index";
import AddWork from "views/ourWorks/AddWork";
import EditWork from "views/ourWorks/EditWork";

const App = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  //selectors
  const { isLoggedIn } = useSelector((state) => state?.authentication);
  const { settings } = useSelector((state) => state.settings);
  const logo = settings?.appLogo;

  useEffect(() => {
    dispatch(getAllSettings());
  }, [dispatch]);

  useEffect(() => {
    if (token) dispatch(getCurrentUser());
  }, [token, dispatch]);

  const RenderApp = () => {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout logo={logo} />}>
              <Route
                path="/"
                element={
                  <AuthRoute>
                    <Dashboard />
                  </AuthRoute>
                }
              />

              {/* home  */}
              <Route
                path="/home/intro"
                element={
                  <AuthRoute>
                    <Intro />
                  </AuthRoute>
                }
              />


              <Route
                path="/home/companyProfile"
                element={
                  <AuthRoute>
                    <CompanyProfile />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/services"
                element={
                  <AuthRoute>
                    <Services />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/companyProfileUpload"
                element={
                  <AuthRoute>
                    <CompanyProfileUpload />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/customerReviews"
                element={
                  <AuthRoute>
                    <CustomerReviews />
                  </AuthRoute>
                }
              />


             
              <Route
                path="/home/statics"
                element={
                  <AuthRoute>
                    <Statics />
                  </AuthRoute>
                }
              />

              {/* about  */}
              <Route
                path="/aboutUs"
                element={
                  <AuthRoute>
                   <Values />
                  </AuthRoute>
                }
              />
             
              <Route
                path="/aboutUs/distinguishUs"
                element={
                  <AuthRoute>
                    <DistinguishUs />
                  </AuthRoute>
                }
              />

            
              <Route
                path="/aboutUs/customerReviews"
                element={
                  <AuthRoute>
                    <CustomerReviewsAbout />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/values"
                element={
                  <AuthRoute>
                    <Values />
                  </AuthRoute>
                }
              />
              {/* partners */}
              <Route
                path="/home/partners"
                element={
                  <AuthRoute>
                    <Partners />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/partners/addPartner"
                element={
                  <AuthRoute>
                    <AddPartner />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/partners/heading"
                element={
                  <AuthRoute>
                    <PartnersHeading />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/partners/:id"
                element={
                  <AuthRoute>
                    <EditPartner />
                  </AuthRoute>
                }
              />
              <Route
                path="/ourServices"
                element={
                  <AuthRoute>
                    <OurServices />
                  </AuthRoute>
                }
              />
              <Route
                path="/ourServices/addService"
                element={
                  <AuthRoute>
                    <AddServices />
                  </AuthRoute>
                }
              />
              <Route
                path="/ourServices/:slug"
                element={
                  <AuthRoute>
                    <EditServices />
                  </AuthRoute>
                }
              />
              <Route
                path="/ourWorks"
                element={
                  <AuthRoute>
                    <OurWorks />
                  </AuthRoute>
                }
              />
              <Route
                path="/ourWorks/addWork"
                element={
                  <AuthRoute>
                    <AddWork />
                  </AuthRoute>
                }
              />
              <Route
                path="/ourWorks/:slug"
                element={
                  <AuthRoute>
                    <EditWork />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs"
                element={
                  <AuthRoute>
                    <Blogs />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/addblog"
                element={
                  <AuthRoute>
                    <AddBlog />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/:id"
                element={
                  <AuthRoute>
                    <EditBlog />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/categories"
                element={
                  <AuthRoute>
                    <BlogCategories />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/categories/addcategory"
                element={
                  <AuthRoute>
                    <AddBlogCategory />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/categories/:id"
                element={
                  <AuthRoute>
                    <EditBlogCategory />
                  </AuthRoute>
                }
              />
             
              <Route
                path="/contactUs"
                element={
                  <AuthRoute>
                    <ContactUs />
                  </AuthRoute>
                }
              />
              <Route
                path="/contactUs/heading"
                element={
                  <AuthRoute>
                    <ContactUsHeading />
                  </AuthRoute>
                }
              />
              <Route
                path="/contactUs/footerBackground"
                element={
                  <AuthRoute>
                    <FooterBackground />
                  </AuthRoute>
                }
              />

              <Route
                path="/contactUs/show/:id"
                element={
                  <AuthRoute>
                    <ShowContact />
                  </AuthRoute>
                }
              />

              {/* socials */}
              <Route
                path="/socials"
                element={
                  <AuthRoute>
                    <Socials />
                  </AuthRoute>
                }
              />

              <Route
                path="/socials/addSocial"
                element={
                  <AuthRoute>
                    <AddSocial />
                  </AuthRoute>
                }
              />

              <Route
                path="/socials/:id"
                element={
                  <AuthRoute>
                    <EditSocial />
                  </AuthRoute>
                }
              />
              {/* socialTypes */}
              <Route
                path="/socialTypes"
                element={
                  <AuthRoute>
                    <SocialTypes />
                  </AuthRoute>
                }
              />

              <Route
                path="/socialTypes/addSocial"
                element={
                  <AuthRoute>
                    <AddSocialTypes />
                  </AuthRoute>
                }
              />

              <Route
                path="/socialTypes/:id"
                element={
                  <AuthRoute>
                    <EditSocialType />
                  </AuthRoute>
                }
              />

              <Route
                path="/settings"
                element={
                  <AuthRoute>
                    <Settings />
                  </AuthRoute>
                }
              />

              <Route
                path="*"
                element={
                  <AuthRoute>
                    <NotFound />
                  </AuthRoute>
                }
              />
            </Route>

            {/*Auth Routes */}
            <Route
              path="/logout"
              element={
                <AuthRoute>
                  <Logout />
                </AuthRoute>
              }
            />
            <Route
              path="/login"
              element={
                <GuestRoute>
                  <Login logo={logo} />
                </GuestRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </Suspense>
    );
  };

  if (!token) return RenderApp();
  if (isLoggedIn !== null) return RenderApp();
  return <Loader />;
};

export default App;
